/**
 * Ponto de registro das etapas 2 (o que é armazenado) e 3 (prontuário). O cadastro só conhece este
 * índice: trocar uma etapa é trocar o componente apontado aqui.
 */
import type { ForwardRefExoticComponent, RefAttributes } from 'react';
import type { ListStepProps, StepHandle } from '../FlammableInstallationWizard.types';
import { StepProdutos } from './StepProdutos';
import { StepProntuario } from './StepProntuario';

export type ListStepComponent = ForwardRefExoticComponent<ListStepProps & RefAttributes<StepHandle>>;

/** Na ordem das etapas 2 e 3. */
export const ETAPAS_DE_REGISTRO: readonly [ListStepComponent, ListStepComponent] = [StepProdutos, StepProntuario];
